<template>
  <Menu
    as="div"
    class="relative z-30 inline-block text-left"
  >
    <MenuButton>
      <ButtonComponent
        :disabled="isDisabled"
        class="!pl-3"
      >
        <img
          src="@/assets/sort-carots.svg"
          alt="sort icon"
        />
        Sort
      </ButtonComponent>
    </MenuButton>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="load-sort-container absolute -right-2 mt-2 w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
      >
        <MenuItem class="p-3">
          <span @click="handleSort('broker')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'broker',
              }"
            >
              Broker
            </p>
          </span>
        </MenuItem>

        <MenuItem class="p-3">
          <span @click="handleSort('expiration')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'expiration',
              }"
            >
              Expiration
            </p>
          </span>
        </MenuItem>

        <MenuItem class="p-3">
          <span @click="handleSort('amount')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'amount',
              }"
            >
              Amount
            </p>
          </span>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { computed, defineProps } from 'vue';
// import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import { ButtonComponent } from '@/components';

// const store = useStore();
const router = useRouter();

defineProps({
  isDisabled: Boolean,
});

const currentSort = computed(() => router.currentRoute.value.query?.sort);

const handleSort = (selected) => {
  console.log('sort selected: ', selected);
  // const existingQueries = router.currentRoute.value.query;
  // if (currentSort?.value !== selected) {
  // store.commit('loads/setLoading', true);
  // router.push({
  //   query: {
  //     // page: 1,
  //     ...existingQueries,
  //     sort: selected,
  //   },
  // });
  // }
};
</script>

<style>
.load-sort-container span {
  all: unset;
}
</style>
